import { render, staticRenderFns } from "./ItemFilterItemAddLayout.vue?vue&type=template&id=50614559&scoped=true"
import script from "./ItemFilterItemAddLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterItemAddLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50614559",
  null
  
)

export default component.exports